import PageNotFound from './pageNotFound';

export default PageNotFound;
